import { useEmbedContentSubscriptionPresentation } from "modules/eventEmbedContent/hooks";
import { selectPresentationModeContent } from "modules/eventEmbedContent/redux";
import { useCompanyPlanSettings } from "modules/companyPlanSettings";
import { selectCurrentEventCompanyPlan } from "modules/event/selectors";
import { useSelector } from "react-redux";
import { PresentContentWindow } from "../PresentContentWindow";

interface Props {
  eventId: string;
}

const PresentContentDisplay = ({ eventId }: Props) => {
  const { loading, error } = useEmbedContentSubscriptionPresentation(eventId);
  const content = useSelector(selectPresentationModeContent);
  const isDisabled = loading || !content || !!error;

  const { isFreePlan } = useCompanyPlanSettings();

  const eventCompanyPlan = useSelector(selectCurrentEventCompanyPlan);

  if (isFreePlan(eventCompanyPlan)) {
    return null;
  }

  if (isDisabled) return null;

  return <PresentContentWindow />;
};

export default PresentContentDisplay;
